// extracted by mini-css-extract-plugin
export default {"wrapper":"O_FileUploads_wrapper__fe2vn","files_wrapper":"O_FileUploads_files_wrapper__wTVal","scroll_bar":"O_FileUploads_scroll_bar__7MGP8"};